import React, { useState } from 'react';
import { ChevronDown, HelpCircle, Sparkles } from 'lucide-react';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState(0);

  const faqs = [
    {
      q: 'Como funciona o sistema de modelos por assinatura?',
      a: 'Você escolhe o modelo de landing page ideal para o seu nicho (Artesanato, Saúde, Mecânica, etc.) e assina um de nossos planos (Mensal, Trimestral ou Anual). Nós cuidamos da hospedagem, manutenção, segurança e suporte contínuo para sua página permanecer no ar vendendo para você.'
    },
    {
      q: 'Posso alterar as fotos, textos e cores do modelo escolhido?',
      a: 'Com certeza! Todos os nossos modelos são 100% personalizáveis com a sua marca, suas fotos de produtos/serviços, seu logotipo, horário de atendimento e contatos.'
    },
    {
      q: 'Como funciona o redirecionamento dos botões para o WhatsApp?',
      a: 'Configuramos os botões de ação (CTA) da sua landing page para direcionar o cliente imediatamente para o seu número de WhatsApp com uma mensagem inicial pré-formatada indicando o interesse dele.'
    },
    {
      q: 'O que está incluso na assinatura vitalícia?',
      a: 'A assinatura vitalícia é uma licença única (a partir de R$ 2.500,00) onde você recebe o código-fonte completo da landing page, customização dedicada sob medida e pode instalar em seu próprio servidor sem mensalidades futuras.'
    },
    {
      q: 'Posso trocar de modelo durante a assinatura?',
      a: 'Sim! Clientes dos planos Trimestral e Anual possuem direito a migrações e atualizações de layout conforme a necessidade do seu negócio.'
    },
    {
      q: 'Como faço para começar a usar meu modelo?',
      a: 'Basta escolher o modelo desejado no catálogo, clicar em "Solicitar orçamento" ou "Escolher plano" e nossa equipe entrará em contato pelo WhatsApp para coletar os dados da sua empresa e ativar sua página em tempo recorde.'
    }
  ];

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq-section" className="section-padding" style={{ backgroundColor: 'var(--bg-main)' }}>
      <div className="container">
        <div className="text-center" style={{ maxWidth: '700px', margin: '0 auto 1.5rem' }}>
          <div className="badge badge-brand" style={{ marginBottom: '0.75rem' }}>
            <Sparkles size={14} />
            Perguntas Frequentes
          </div>
          <h2 style={{ fontSize: '2.5rem', color: 'var(--text-title)' }}>
            Seção de Dúvidas
          </h2>
          <p style={{ color: 'var(--text-muted)', fontSize: '1.05rem', marginTop: '0.5rem' }}>
            Tire todas as suas dúvidas sobre nossas assinaturas e funcionamento dos modelos.
          </p>
        </div>

        <div className="faq-container">
          {faqs.map((faq, idx) => {
            const isOpen = openIndex === idx;
            return (
              <div key={idx} className={`faq-item ${isOpen ? 'active' : ''}`}>
                <button 
                  className="faq-question" 
                  onClick={() => toggleFaq(idx)}
                  aria-expanded={isOpen}
                >
                  <span style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                    <HelpCircle size={18} color="var(--color-brand-primary)" />
                    {faq.q}
                  </span>
                  <ChevronDown 
                    size={20} 
                    style={{ 
                      transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)', 
                      transition: 'transform 0.2s ease',
                      color: 'var(--text-muted)'
                    }} 
                  />
                </button>

                {isOpen && (
                  <div className="faq-answer animate-fade-in">
                    {faq.a}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
